export const GET_EVENTS_RECORDS = "GET_EVENTS_RECORDS";
export const GET_EVENTS_RECORDS_ERROR = "GET_EVENTS_RECORDS_ERROR";
export const GET_EVENTS_RECORDS_SUCCESS = "GET_EVENTS_RECORDS_SUCCESS";
